import { defineMessages } from '@formatjs/intl'

export const messages = defineMessages({
    search: {
        id: 'global.search',
        defaultMessage: 'Search',
    },
    delete: {
        id: 'global.delete',
        defaultMessage: 'Delete',
    },
    deleting: {
        id: 'global.deleting',
        defaultMessage: 'Deleting',
    },
    name: {
        id: 'global.name',
        defaultMessage: 'Name',
    },
    status: {
        id: 'global.status',
        defaultMessage: 'Status',
    },
    action: {
        id: 'global.action',
        defaultMessage: 'Action',
    },
    select: {
        id: 'global.action',
        defaultMessage: 'Select',
    },
    cancel: {
        id: 'global.cancel',
        defaultMessage: 'Cancel',
    },
    view: {
        id: 'global.view',
        defaultMessage: 'View',
    },
    update: {
        id: 'global.update',
        defaultMessage: 'Update',
    },
    pageNotFound: {
        id: 'global.pageNotFound',
        defaultMessage: 'Page not found',
    },
    loading: {
        id: 'global.loading',
        defaultMessage: 'Loading',
    },
    edit: {
        id: 'global.edit',
        defaultMessage: 'Edit',
    },
    reset: {
        id: 'global.reset',
        defaultMessage: 'Reset',
    },
    pendingCommands: {
        id: 'global.pendingCommands',
        defaultMessage: 'Pending commands',
    },
    online: {
        id: 'global.online',
        defaultMessage: 'online',
    },
    offline: {
        id: 'global.offline',
        defaultMessage: 'offline',
    },
    id: {
        id: 'global.id',
        defaultMessage: 'ID',
    },
    copy: {
        id: 'global.copy',
        defaultMessage: 'Copy',
    },
    information: {
        id: 'global.information',
        defaultMessage: 'Information',
    },
    editName: {
        id: 'global.editName',
        defaultMessage: 'Edit name',
    },
    close: {
        id: 'global.close',
        defaultMessage: 'Close',
    },
    saveChange: {
        id: 'global.saveChange',
        defaultMessage: 'Save Change',
    },
    savingChanges: {
        id: 'global.savingChanges',
        defaultMessage: 'Saving Changes',
    },
    done: {
        id: 'global.done',
        defaultMessage: 'Done',
    },
    created: {
        id: 'global.created',
        defaultMessage: 'Created',
    },
    expires: {
        id: 'global.expires',
        defaultMessage: 'Expires',
    },
    configuration: {
        id: 'global.configuration',
        defaultMessage: 'Configuration',
    },
    themePreviewMode: {
        id: 'global.themePreviewMode',
        defaultMessage: 'Theme Preview Mode',
    },
    ownerID: {
        id: 'global.ownerID',
        defaultMessage: 'Owner ID',
    },
    owner: {
        id: 'global.owner',
        defaultMessage: 'Owner',
    },
    linkedHub: {
        id: 'global.linkedHub',
        defaultMessage: 'Linked Hub',
    },
    certificate: {
        id: 'global.certificate',
        defaultMessage: 'Certificate',
    },
    changesMade: {
        id: 'global.changesMade',
        defaultMessage: 'Changes made',
    },
    saveChanges: {
        id: 'global.saveChanges',
        defaultMessage: 'Save changes',
    },
    resetChanges: {
        id: 'global.resetChanges',
        defaultMessage: 'Reset changes',
    },
    ok: {
        id: 'global.ok',
        defaultMessage: 'Ok',
    },
    logOut: {
        id: 'global.logOut',
        defaultMessage: 'Log out',
    },
    navigation: {
        id: 'global.navigation',
        defaultMessage: 'Navigation',
    },
    on: {
        id: 'global.on',
        defaultMessage: 'On',
    },
    off: {
        id: 'global.off',
        defaultMessage: 'Off',
    },
    tls: {
        id: 'global.tls',
        defaultMessage: 'TLS',
    },
    tlsDescription: {
        id: 'global.tlsDescription',
        defaultMessage:
            'Configure a client certificate if communication between the Device Provisioning service and the Certificate Authority service requires it.',
    },
    showMore: {
        id: 'global.showMore',
        defaultMessage: 'Show More',
    },
    requiredField: {
        id: 'global.requiredField',
        defaultMessage: 'Required field {field}',
    },
    minLength: {
        id: 'global.minLength',
        defaultMessage: 'Minimum length for field {field} is {length}',
    },
    minValue: {
        id: 'global.minValue',
        defaultMessage: 'Minimum value for field {field} is {length}',
    },
    maxValue: {
        id: 'global.maxValue',
        defaultMessage: 'Maximum value for field {field} is {length}',
    },
    default: {
        id: 'global.default',
        defaultMessage: 'default',
    },
    yes: {
        id: 'global.yes',
        defaultMessage: 'Yes',
    },
    no: {
        id: 'global.no',
        defaultMessage: 'No',
    },
    version: {
        id: 'global.version',
        defaultMessage: 'Version',
    },
    download: {
        id: 'global.download',
        defaultMessage: 'Download',
    },
    finish: {
        id: 'global.finish',
        defaultMessage: 'Finish',
    },
    show: {
        id: 'global.show',
        defaultMessage: 'Show',
    },
    hide: {
        id: 'global.hide',
        defaultMessage: 'Hide',
    },
    editorPlaceholder: {
        id: 'global.editorPlaceholder',
        defaultMessage: 'Write your code or Drag & Drop your file here',
    },
    back: {
        id: 'global.back',
        defaultMessage: 'Back',
    },
    continue: {
        id: 'global.continue',
        defaultMessage: 'Continue',
    },
    unit: {
        id: 'global.unit',
        defaultMessage: 'Unit',
    },
    placeholder: {
        id: 'global.placeholder',
        defaultMessage: 'Placeholder',
    },
    time: {
        id: 'global.time',
        defaultMessage: 'Time',
    },
    timeout: {
        id: 'global.timeout',
        defaultMessage: 'Timeout',
    },
    metric: {
        id: 'global.metric',
        defaultMessage: 'Metric',
    },
    valid: {
        id: 'global.valid',
        defaultMessage: 'Valid',
    },
    expired: {
        id: 'global.expired',
        defaultMessage: 'Expired',
    },
    hubId: {
        id: 'global.hubId',
        defaultMessage: 'Hub ID',
    },
    more: {
        id: 'global.more',
        defaultMessage: 'More',
    },
    key: {
        id: 'global.key',
        defaultMessage: 'Key',
    },
    anonymous: {
        id: 'global.anonymous',
        defaultMessage: 'Anonymous',
    },
    device: {
        id: 'global.device',
        defaultMessage: 'Device',
    },
    copyToClipboard: {
        id: 'global.copyToClipboard',
        defaultMessage: 'Copy to clipboard',
    },
    uploadedCaPools: {
        id: 'global.uploadedCaPools',
        defaultMessage: 'Uploaded CA Pools',
    },
    promptTitle: {
        id: 'global.promptTitle',
        defaultMessage: 'Leave without saving the changes',
    },
    promptText: {
        id: 'global.promptText',
        defaultMessage: 'In case of non-confirmation, any changes you have made will be reset to the original settings.',
    },
    promptLeave: {
        id: 'global.promptLeave',
        defaultMessage: 'Leave without Saving',
    },
    promptContinue: {
        id: 'global.promptContinue',
        defaultMessage: 'Continue editing',
    },
    promptDefaultMessage: {
        id: 'global.promptDefaultMessage',
        defaultMessage: 'Are you sure you want to leave?',
    },
    create: {
        id: 'global.create',
        defaultMessage: 'Create',
    },
    invalidUUID: {
        id: 'global.invalidUUID',
        defaultMessage: 'Invalid field format {field}',
    },
    invalidFormState: {
        id: 'global.invalidFormState',
        defaultMessage: 'To continue, you must fill in the details above.',
    },
    requiredMessage: {
        id: 'global.requiredMessage',
        defaultMessage: 'Fill in and check the information above. All fields marked with (*) are required.',
    },
    details: {
        id: 'global.details',
        defaultMessage: 'Details',
    },
    showAdvancedConfiguration: {
        id: 'global.showAdvancedConfiguration',
        defaultMessage: 'Show advanced configuration',
    },
    hideAdvancedConfiguration: {
        id: 'global.hideAdvancedConfiguration',
        defaultMessage: 'Hide advanced configuration',
    },
    advancedView: {
        id: 'global.advancedView',
        defaultMessage: 'Advanced view',
    },
    invalidNumber: {
        id: 'global.invalidNumber',
        defaultMessage: 'Invalid number',
    },
    undoneAction: {
        id: 'global.undoneAction',
        defaultMessage: 'This action cannot be undone.',
    },
    general: {
        id: 'global.general',
        defaultMessage: 'General',
    },
    listOfResources: {
        id: 'global.listOfResources',
        defaultMessage: 'List of Resources',
    },
    href: {
        id: 'global.href',
        defaultMessage: 'Href',
    },
    timeToLive: {
        id: 'global.timeToLive',
        defaultMessage: 'Time to live',
    },
    second: {
        id: 'global.second',
        defaultMessage: 'second',
    },
    fullView: {
        id: 'global.fullView',
        defaultMessage: 'Full View',
    },
    compactView: {
        id: 'global.compactView',
        defaultMessage: 'Compact View',
    },
    deleteResource: {
        id: 'global.deleteResource',
        defaultMessage: 'Delete Resource',
    },
    lastModified: {
        id: 'global.lastModified',
        defaultMessage: 'Last Modified',
    },
    link: {
        id: 'global.link',
        defaultMessage: 'Link',
    },
    enabled: {
        id: 'global.enabled',
        defaultMessage: 'Enabled',
    },
    disabled: {
        id: 'global.disabled',
        defaultMessage: 'Disabled',
    },
    filters: {
        id: 'global.filters',
        defaultMessage: 'Filters',
    },
    deviceId: {
        id: 'global.deviceId',
        defaultMessage: 'Device ID',
    },
    selectOrCreate: {
        id: 'global.selectOrCreate',
        defaultMessage: 'Select or type to create',
    },
    setUp: {
        id: 'global.setUp',
        defaultMessage: 'Set Up',
    },
    notSet: {
        id: 'global.notSet',
        defaultMessage: 'Not Set',
    },
    deviceName: {
        id: 'global.deviceName',
        defaultMessage: 'Device name',
    },
    keepAlive: {
        id: 'global.keepAlive',
        defaultMessage: 'Keep alive',
    },
    content: {
        id: 'global.content',
        defaultMessage: 'Content',
    },
    duration: {
        id: 'global.duration',
        defaultMessage: 'Duration',
    },
    add: {
        id: 'global.add',
        defaultMessage: 'Add',
    },
    setDevices: {
        id: 'global.setDevices',
        defaultMessage: 'Set Devices',
    },
    createAndSave: {
        id: 'global.createAndSave',
        defaultMessage: 'Create and Save',
    },
    deviceSelected: {
        id: 'global.deviceSelected',
        defaultMessage: 'device selected',
    },
    devicesSelected: {
        id: 'global.devicesSelected',
        defaultMessage: 'devices selected',
    },
    error: {
        id: 'global.error',
        defaultMessage: 'Error',
    },
    pending: {
        id: 'global.pending',
        defaultMessage: 'Pending',
    },
    success: {
        id: 'global.success',
        defaultMessage: 'Success',
    },
    noDevices: {
        id: 'global.noDevices',
        defaultMessage: 'No Devices',
    },
    canceled: {
        id: 'global.canceled',
        defaultMessage: 'Canceled',
    },
    invoke: {
        id: 'global.invoke',
        defaultMessage: 'Invoke',
    },
    generate: {
        id: 'global.generate',
        defaultMessage: 'Generate',
    },
    note: {
        id: 'global.note',
        defaultMessage: 'Note',
    },
    days: {
        id: 'global.days',
        defaultMessage: 'days',
    },
    custom: {
        id: 'global.custom',
        defaultMessage: 'Custom',
    },
    revoke: {
        id: 'global.revoke',
        defaultMessage: 'Revoke',
    },
    confirm: {
        id: 'global.confirm',
        defaultMessage: 'Confirm',
    },
    clear: {
        id: 'global.clear',
        defaultMessage: 'Clear',
    },
})
